export const defaultMaxOverlappedItems = 2;
